// Controls the sidebar navigation items and their structure for different user modules
import Person from "@mui/icons-material/Person";
import Logout from "@mui/icons-material/Logout";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import PeopleIcon from "@mui/icons-material/People";
import AccountCircle from "@mui/icons-material/AccountCircle";
import InfoOutline from "@mui/icons-material/InfoOutline";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import EmailIcon from "@mui/icons-material/Email";
import { BIOBANK_ROUTES, ADMIN_ROUTES, RESEARCHER_ROUTES, AUTH_ROUTES } from "./routes";

// Navigation item types
export const NAV_ITEM_TYPES = {
  ROUTE: "route",
  EXTERNAL: "external",
  ACTION: "action",
  DIVIDER: "divider",
};

// Admin navigation items
export const ADMIN_NAV_ITEMS = [
  {
    text: "Dashboard",
    path: ADMIN_ROUTES.DASHBOARD,
    iconName: "dashboard",
    type: NAV_ITEM_TYPES.ROUTE,
  },
  {
    text: "REDCap Data",
    path: ADMIN_ROUTES.REDCAP,
    iconName: "reports",
    type: NAV_ITEM_TYPES.ROUTE,
  },
  {
    text: "Consent Management",
    path: ADMIN_ROUTES.CONSENT_MANAGEMENT,
    iconName: "consent-management",
    type: NAV_ITEM_TYPES.ROUTE,
  },
  {
    text: "Reviews & Approvals",
    path: ADMIN_ROUTES.REVIEWS_APPROVALS,
    icon: AssignmentTurnedInIcon,
    type: NAV_ITEM_TYPES.ROUTE,
  },
  {
    text: "User Management",
    path: ADMIN_ROUTES.USER_MANAGEMENT,
    icon: PeopleIcon,
    type: NAV_ITEM_TYPES.ROUTE,
  },
  {
    text: "Sample Data",
    path: ADMIN_ROUTES.SAMPLE_DATA,
    iconName: "bio-bank",
    type: NAV_ITEM_TYPES.ROUTE,
  },
  {
    text: "Participant Data",
    path: ADMIN_ROUTES.PATIENT_DATA,
    icon: AccountCircle,
    type: NAV_ITEM_TYPES.ROUTE,
  },
  {
    text: "Program Directory",
    path: ADMIN_ROUTES.PROGRAMS,
    icon: InfoOutline,
    type: NAV_ITEM_TYPES.ROUTE,
  },
];

// BioBank navigation items
export const BIOBANK_NAV_ITEMS = [
  {
    text: "Dashboard",
    path: BIOBANK_ROUTES.DASHBOARD,
    iconName: "dashboard",
    type: NAV_ITEM_TYPES.ROUTE,
  },
  {
    text: "Collection Kits",
    iconName: "collection-kits",
    path: BIOBANK_ROUTES.COLLECTION_KITS,
    type: NAV_ITEM_TYPES.ROUTE,
  },
  {
    text: "Participant Scheduling",
    path: BIOBANK_ROUTES.PARTICIPANT_SCHEDULING,
    iconName: "patient-scheduling",
    type: NAV_ITEM_TYPES.ROUTE,
  },
  {
    text: "Participant Check-In",
    path: BIOBANK_ROUTES.PARTICIPANT_CHECKIN,
    iconName: "patient-checkin",
    type: NAV_ITEM_TYPES.ROUTE,
  },
  {
    text: "Sample Collection",
    path: BIOBANK_ROUTES.SAMPLE_COLLECTION,
    iconName: "bio-bank",
    type: NAV_ITEM_TYPES.ROUTE,
  },
  {
    text: "Sample Processing",
    path: BIOBANK_ROUTES.SAMPLE_PROCESSING,
    iconName: "micro-sample",
    type: NAV_ITEM_TYPES.ROUTE,
  },
  {
    text: "Aliquot Management",
    path: BIOBANK_ROUTES.ALIQUOT_MANAGEMENT,
    iconName: "receipt-filled",
    type: NAV_ITEM_TYPES.ROUTE,
  },
    {
    text: "Follow-Up Management",
    path: BIOBANK_ROUTES.FOLLOWUP_MANAGEMENT,
    iconName: "reports",
    type: NAV_ITEM_TYPES.ROUTE,
  },
  {
    text: "Project Management",
    iconName: "research",
    path: BIOBANK_ROUTES.PROJECT_MANAGEMENT,
    type: NAV_ITEM_TYPES.ROUTE,
  },
  {
    text: "Email Center",
    path: BIOBANK_ROUTES.EMAIL_CENTER,
    icon: EmailIcon,
    type: NAV_ITEM_TYPES.ROUTE,
  },
];

// Researcher navigation items
export const RESEARCHER_NAV_ITEMS = [
  {
    text: "Dashboard",
    path: RESEARCHER_ROUTES.DASHBOARD,
    iconName: "dashboard",
    type: NAV_ITEM_TYPES.ROUTE,
  },
  {
    text: "Research Projects",
    path: RESEARCHER_ROUTES.PROJECTS,
    iconName: "research",
    type: NAV_ITEM_TYPES.ROUTE,
  },
  {
    text: "Data Analysis",
    path: RESEARCHER_ROUTES.ANALYSIS,
    iconName: "analysis",
    type: NAV_ITEM_TYPES.ROUTE,
  },
  {
    text: "Reports",
    path: RESEARCHER_ROUTES.REPORTS,
    iconName: "reports",
    type: NAV_ITEM_TYPES.ROUTE,
  },
];

// Top-level navigation items based on user groups
export const TOP_LEVEL_NAV_ITEMS = [
  {
    text: "Admin",
    path: ADMIN_ROUTES.DASHBOARD,
    iconName: "admin",
    type: NAV_ITEM_TYPES.ROUTE,
    group: "admin",
    children: ADMIN_NAV_ITEMS,
  },
  {
    text: "BioBank",
    path: BIOBANK_ROUTES.DASHBOARD,
    iconName: "bio-bank",
    type: NAV_ITEM_TYPES.ROUTE,
    group: "biobank",
    children: BIOBANK_NAV_ITEMS,
  },
  {
    text: "Researcher",
    path: RESEARCHER_ROUTES.DASHBOARD,
    iconName: "researcher",
    type: NAV_ITEM_TYPES.ROUTE,
    group: "researcher",
    children: RESEARCHER_NAV_ITEMS,
  },
];

// Bottom navigation items (shared between main and admin)
export const BOTTOM_NAV_ITEMS = [
  {
    text: "Profile",
    path: BIOBANK_ROUTES.PROFILE,
    icon: Person,
    type: NAV_ITEM_TYPES.ROUTE,
  },
  {
    text: "Logout",
    path: AUTH_ROUTES.LOGOUT,
    icon: Logout,
    type: NAV_ITEM_TYPES.ACTION,
    action: "logout",
  },
];

// Admin-specific bottom navigation items
export const ADMIN_BOTTOM_NAV_ITEMS = [
  {
    text: "Profile",
    path: BIOBANK_ROUTES.PROFILE,
    icon: Person,
    type: NAV_ITEM_TYPES.ROUTE,
  },
  {
    text: "Logout",
    path: AUTH_ROUTES.LOGOUT,
    icon: Logout,
    type: NAV_ITEM_TYPES.ACTION,
    action: "logout",
  },
];

// Admin module navigation item removed - admin is now integrated into main app

// Navigation themes and styling constants
export const NAVIGATION_THEME = {
  colors: {
    primary: "#500000",
    primaryHover: "#4a0000",
    text: "#666666",
    textActive: "#FFFFFF",
    background: "transparent",
    backgroundHover: "#f5f5f5",
    backgroundActive: "#500000",
    border: "#500000",
  },
  spacing: {
    itemPadding: 2,
    subItemPadding: 4,
    iconWidth: 40,
  },
  typography: {
    fontSize: "0.875rem",
    fontWeight: {
      normal: "normal",
      bold: "bold",
    },
  },
};

// Navigation item validation
export const validateNavigationItem = (item) => {
  const requiredFields = ["text", "type"];
  const missingFields = requiredFields.filter((field) => !item[field]);

  if (missingFields.length > 0) {
    console.warn(
      `Navigation item missing required fields: ${missingFields.join(", ")}`,
      item
    );
    return false;
  }

  if (item.type === NAV_ITEM_TYPES.ROUTE && !item.path) {
    console.warn("Route navigation item missing path", item);
    return false;
  }

  if (item.type === NAV_ITEM_TYPES.ACTION && !item.action) {
    console.warn("Action navigation item missing action", item);
    return false;
  }

  return true;
};

// Helper function to get navigation items based on user groups and current location
export const getNavigationItems = (userGroups = [], currentPath = "") => {
  // Filter top-level items based on user groups
  const availableTopLevelItems = TOP_LEVEL_NAV_ITEMS.filter((item) => {
    if (!item.group) return true; // Include items without group restrictions
    return userGroups.includes(item.group);
  });

  // Determine bottom navigation items based on current location
  // If user is in the admin section, use admin profile, otherwise use dashboard profile
  const isInAdminSection = currentPath.startsWith("/admin");

  const bottomItems = isInAdminSection
    ? ADMIN_BOTTOM_NAV_ITEMS
    : BOTTOM_NAV_ITEMS;

  return {
    main: availableTopLevelItems,
    bottom: bottomItems,
    topLevel: availableTopLevelItems,
  };
};
